import {selectIsPWA} from '../state/selectors/global';
import {resetCurrentFlow} from '../state/slice/monitoring';
import {
    resetInitialCodentify,
    resetInitialConnectionType,
    resetInitialDeviceType,
    resetInitialDusn,
    resetInitialHolderDusn,
    resetQrCodentify,
    setShouldSetupGuideBeShown,
} from '../state/slice/session';
import {dispatch, getState} from '../state/store';
import storageService from './storageService';

/**
 * Marks the initial setup guide as shown.
 * After this, the user will not see the setup guide again in the future.
 *
 * For PWA, we also set an extra flag in localStorage,
 * since initial setup data is stored in the PWA manifest.
 * This ensures the guide is only shown once, even in PWA.
 */
const markSetupGuideAsShown = () => {
    dispatch(setShouldSetupGuideBeShown(false));

    if (selectIsPWA(getState())) storageService.setIsInitialSetupCompleted();
};

const resetInitialSetupState = () => {
    dispatch(resetInitialCodentify());
    dispatch(resetInitialConnectionType());
    dispatch(resetInitialDeviceType());
    dispatch(resetInitialDusn());
    dispatch(resetInitialHolderDusn());
    dispatch(resetQrCodentify());
    dispatch(resetCurrentFlow());
};

export default {
    markSetupGuideAsShown,
    resetInitialSetupState,
};
